/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    asset: "A - TÀI SẢN NGẮN HẠN (100 = 110 + 120 + 130 + 140 + 150)",
    number: 100,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 1,
    asset: "I. Tiền và các khoản tương đương tiền (110 = 111 + 112)",
    number: 110,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 2,
    asset: "1. Tiền",
    number: 111,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 3,
    asset: "2. Các khoản tương đương tiền",
    number: 112,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 4,
    asset: "II. Đầu tư tài chính ngắn hạn (120 = 121 + 122 + 123)",
    number: 120,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 5,
    asset: "1. Chứng khoán kinh doanh",
    number: 121,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 6,
    asset: "2. Dự phòng giảm giá chứng khoán kinh doanh (*)",
    number: 122,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 7,
    asset: "3. Đầu tư nắm giữ đến ngày đáo hạn",
    number: 123,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 8,
    asset: "III. Các khoản phải thu ngắn hạn (130 = 131 + 132 + 133 + 134 + 135 + 136 + 137 + 139)",
    number: 130,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 9,
    asset: "1. Phải thu ngắn hạn của khách hàng",
    number: 131,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 10,
    asset: "2. Trả trước cho người bán ngắn hạn",
    number: 132,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 11,
    asset: "3. Phải thu nội bộ ngắn hạn",
    number: 133,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 12,
    asset: "4. Phải thu theo tiến độ kế hoạch hợp đồng xây dựng",
    number: 134,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 13,
    asset: "5. Phải thu về cho vay ngắn hạn",
    number: 135,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 14,
    asset: "6. Phải thu ngắn hạn khác",
    number: 136,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 15,
    asset: "7. Dự phòng phải thu ngắn hạn khó đòi (*)",
    number: 137,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 16,
    asset: "8. Tài sản thiếu chờ xử lý",
    number: 139,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 17,
    asset: "IV. Hàng tồn kho (140 = 141 + 149)",
    number: 140,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 18,
    asset: "1. Hàng tồn kho",
    number: 141,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 19,
    asset: "2. Dự phòng giảm giá hàng tồn kho (*)",
    number: 149,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 20,
    asset: "V. Tài sản ngắn hạn khác (150 = 151 + 152 + 153 + 154 + 155)",
    number: 150,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 21,
    asset: "1. Chi phí trả trước ngắn hạn",
    number: 151,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 22,
    asset: "2. Thuế GTGT được khấu trừ",
    number: 152,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 23,
    asset: "3. Thuế và các khoản khác phải thu Nhà nước",
    number: 153,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 24,
    asset: "4. Giao dịch mua bán lại trái phiếu Chính phủ",
    number: 154,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 25,
    asset: "5. Tài sản ngắn hạn khác",
    number: 155,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 26,
    asset: "B - TÀI SẢN DÀI HẠN (200 = 210 + 220 + 230 + 240 + 250 + 260)",
    number: 200,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 27,
    asset: "I. Các khoản phải thu dài hạn (210 = 211 + 212 + 213 + 214 + 215 + 216 + 219)",
    number: 210,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 28,
    asset: "1. Phải thu dài hạn của khách hàng",
    number: 211,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 29,
    asset: "2. Trả trước cho người bán dài hạn",
    number: 212,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 30,
    asset: "3. Vốn kinh doanh ở đơn vị trực thuộc",
    number: 213,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 31,
    asset: "4. Phải thu nội bộ dài hạn",
    number: 214,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 32,
    asset: "5. Phải thu về cho vay dài hạn",
    number: 215,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 33,
    asset: "6. Phải thu dài hạn khác",
    number: 216,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 34,
    asset: "7. Dự phòng phải thu dài hạn khó đòi (*)",
    number: 219,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 35,
    asset: "II. Tài sản cố định (220 = 221 + 224 + 227)",
    number: 220,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 36,
    asset: "1. Tài sản cố định hữu hình (221 = 222 + 223)",
    number: 221,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 37,
    asset: "- Nguyên giá",
    number: 222,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 38,
    asset: "- Giá trị hao mòn lũy kế (*)",
    number: 223,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 39,
    asset: "2. Tài sản cố định thuê tài chính (224 = 225 + 226)",
    number: 224,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 40,
    asset: "- Nguyên giá",
    number: 225,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 41,
    asset: "- Giá trị hao mòn lũy kế (*)",
    number: 226,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 42,
    asset: "3. Tài sản cố định vô hình (227 = 228 + 229)",
    number: 227,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 43,
    asset: "- Nguyên giá",
    number: 228,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 44,
    asset: "- Giá trị hao mòn lũy kế (*)",
    number: 229,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 45,
    asset: "IV. Tài sản dở dang dài hạn (240 = 241 + 242)",
    number: 240,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 46,
    asset: "1. Chi phí sản xuất, kinh doanh dở dang dài hạn",
    number: 241,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 47,
    asset: "2. Chi phí xây dựng cơ bản dở dang",
    number: 242,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 48,
    asset: "V. Đầu tư tài chính dài hạn (250 = 251 + 252 + 253 + 254 + 255)",
    number: 250,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 49,
    asset: "1. Đầu tư vào công ty con",
    number: 251,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 50,
    asset: "2. Đầu tư vào công ty liên doanh, liên kết",
    number: 252,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 51,
    asset: "3. Đầu tư góp vốn vào đơn vị khác",
    number: 253,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 52,
    asset: "4. Dự phòng đầu tư tài chính dài hạn (*)",
    number: 254,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 53,
    asset: "5. Đầu tư nắm giữ đến ngày đáo hạn",
    number: 255,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 54,
    asset: "VI. Tài sản dài hạn khác (260 = 261 + 262 + 263 + 268)",
    number: 260,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 55,
    asset: "1. Chi phí trả trước dài hạn",
    number: 261,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 56,
    asset: "2. Tài sản thuế thu nhập hoãn lại",
    number: 262,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 57,
    asset: "3. Thiết bị, vật tư, phụ tùng thay thế dài hạn",
    number: 263,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 58,
    asset: "4. Tài sản dài hạn khác",
    number: 268,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 59,
    asset: "TỔNG CỘNG TÀI SẢN (270 = 100 + 200)",
    number: 270,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 60,
    asset: "C - NỢ PHẢI TRẢ (300 = 310 + 330)",
    number: 300,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 61,
    asset: "I. Nợ ngắn hạn (310 = 311 + 312 + ... + 322 + 323 + 324)",
    number: 310,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 62,
    asset: "1. Phải trả người bán ngắn hạn",
    number: 311,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 63,
    asset: "2. Người mua trả tiền trước ngắn hạn",
    number: 312,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 64,
    asset: "3. Thuế và các khoản phải nộp Nhà nước",
    number: 313,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 65,
    asset: "4. Phải trả người lao động",
    number: 314,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 66,
    asset: "5. Chi phí phải trả ngắn hạn",
    number: 315,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 67,
    asset: "6. Phải trả nội bộ ngắn hạn",
    number: 316,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 68,
    asset: "7. Phải trả theo tiến độ kế hoạch hợp đồng xây dựng",
    number: 317,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 69,
    asset: "8. Doanh thu chưa thực hiện ngắn hạn",
    number: 318,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 70,
    asset: "9. Phải trả ngắn hạn khác",
    number: 319,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 71,
    asset: "10. Vay và nợ thuê tài chính ngắn hạn",
    number: 320,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 72,
    asset: "11. Dự phòng phải trả ngắn hạn",
    number: 321,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 73,
    asset: "12. Quỹ khen thưởng, phúc lợi",
    number: 322,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 74,
    asset: "13. Quỹ bình ổn giá",
    number: 323,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 75,
    asset: "14. Giao dịch mua bán lại trái phiếu Chính phủ",
    number: 324,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 76,
    asset: "II. Nợ dài hạn (330 = 331 + 332 + ... + 342 + 343)",
    number: 330,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 77,
    asset: "1. Phải trả người bán dài hạn",
    number: 331,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 78,
    asset: "2. Người mua trả tiền trước dài hạn",
    number: 332,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 79,
    asset: "3. Chi phí phải trả dài hạn",
    number: 333,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 80,
    asset: "4. Phải trả nội bộ về vốn kinh doanh",
    number: 334,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 81,
    asset: "5. Phải trả nội bộ dài hạn",
    number: 335,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 82,
    asset: "6. Doanh thu chưa thực hiện dài hạn",
    number: 336,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 83,
    asset: "7. Phải trả dài hạn khác",
    number: 337,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 84,
    asset: "8. Vay và trả nợ thuê tài chính dài hạn",
    number: 338,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 85,
    asset: "9. Quỹ hỗ trợ sắp xếp doanh nghiệp",
    number: 339,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 86,
    asset: "10. Cỗ phiếu ưu đãi",
    number: 340,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 87,
    asset: "11. Thuế thu nhập hoãn lại phải trả",
    number: 341,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 88,
    asset: "12. Dự phòng phải trả dài hạn",
    number: 342,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 89,
    asset: "13. Quỹ phát triển khoa học và công nghệ",
    number: 343,
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 90,
    asset: "D - VỐN CHỦ SỞ HỮU (400 = 410 + 430)",
    number: 400,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 91,
    asset: "I. Vốn chủ sở hữu (400 = 411 + 412 + ... + 420 + 421 + 422)",
    number: 410,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 92,
    asset: "1. Vốn góp của chủ sở hữu (411 = 411a + 411b)",
    number: 411,
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 93,
    asset: "- Cổ phiếu phổ thông có quyền biểu quyết",
    number: "411a",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 94,
    asset: "- Cổ phiếu ưu đãi",
    number: "411b",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 95,
    asset: "2. Thặng dư vốn cổ phần",
    number: "412",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 96,
    asset: "3. Quyền chọn chuyển đổi cổ phiếu",
    number: "413",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 97,
    asset: "4. Vốn khác của chủ sở hữu",
    number: "414",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 98,
    asset: "5. Cổ phiếu quỹ (*)",
    number: "415",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 99,
    asset: "6. Chênh lệch đánh giá lại tài sản",
    number: "416",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 100,
    asset: "7. Chênh lệch tỷ giá hối đoái",
    number: "417",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 101,
    asset: "8. Quỹ đầu tư phát triển",
    number: "418",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 102,
    asset: "9. Quỹ hỗ trợ sắp xếp doanh nghiệp",
    number: "419",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 103,
    asset: "10. Quỹ khác thuộc vốn chủ sở hữu",
    number: "420",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 104,
    asset: "11. Lợi nhuận sau thuế chưa phân phối (421 = 421a + 421b)",
    number: "421",
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 105,
    asset: "- LNST chưa phân phối lũy kế đến cuối kỳ trước",
    number: "421a",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 106,
    asset: "- LNST chưa phân phối kỳ này",
    number: "421b",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 107,
    asset: "12. Nguồn vốn đầu tư XDCB",
    number: "422",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 108,
    asset: "II. Nguồn kinh phí và quỹ khác (430 = 431 + 432)",
    number: "430",
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 109,
    asset: "1. Nguồn kinh phí",
    number: "431",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 110,
    asset: "2. Nguồn kinh phí đã hình thành TSCĐ",
    number: "432",
    readOnly: false,
    value: { present: "", end: 0, start: 0 },
  },
  {
    id: 111,
    asset: "TỔNG CỘNG NGUỒN VỐN (440 = 300 + 400)",
    number: "440",
    readOnly: true,
    value: { present: "", end: 0, start: 0 },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>TÀI SẢN</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Số cuối năm</Th>
              <Th style={{ textAlign: "center" }}>Số đầu năm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
              <Th style={{ textAlign: "center" }}>3</Th>
              <Th style={{ textAlign: "center" }}>4</Th>
              <Th style={{ textAlign: "center" }}>5</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    {rows.number}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      value={rows.value.present}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="end"
                      readOnly={rows.readOnly}
                      fontWeight={rows.readOnly}
                      value={rows.value.end}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="start"
                      readOnly={rows.readOnly}
                      fontWeight={rows.readOnly}
                      value={rows.value.start}
                      onChange={handleChange}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable2(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
